import * as React from "react";
import { forwardRef } from "react";
const SvgCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.87451 11.9943L11.9945 2.87427L13.1259 4.00565L4.00589 13.1256L2.87451 11.9943Z" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9945 13.1257L2.87451 4.00565L4.0059 2.87427L13.1259 11.9943L11.9945 13.1257Z" }));
const ForwardRef = forwardRef(SvgCross);
export default ForwardRef;
